import {ClientInfosSummary} from "./client-informations-summary";
import {EmployeeRoleEnum} from "../enum/employee-role.enum";
import { ServiceLineSummary } from "./service-line-summary";

export class QuoteSummary {
    public reference?: string;
    public totalWeeklyAmount?: string;
    public totalMonthlyAmount?: string;
    public serviceLines?: ServiceLineSummary[];
    public clientInfos?: ClientInfosSummary;
    public creationDate?: string;
    public countryIsoCode?: string;
    public employeeRole?: EmployeeRoleEnum;
    public securityDeposit?: string;
    public paymentMethod?: string;
    public paymentCondition?: string;
    public withPresentationPages?: boolean;

    public bevMonthlyAmount?: string;
    public showRenewalContent?: boolean;
    public bevNewQuoteServiceMonthlyAmount?: string;

    constructor(reference?: string, totalWeeklyAmount?: string, totalMonthlyAmount?: string, serviceLines?: ServiceLineSummary[], clientInfos?: ClientInfosSummary, creationDate?: string, countryIsoCode?: string, employeeRole?: EmployeeRoleEnum, securityDeposit?: string, paymentMethod?: string, paymentCondition?: string, withPresentationPages?: boolean, bevMonthlyAmount?: string, showRenewalContent?: boolean, bevNewQuoteServiceMonthlyAmount?: string) {
        this.reference = reference;
        this.totalWeeklyAmount = totalWeeklyAmount;
        this.totalMonthlyAmount = totalMonthlyAmount;
        this.serviceLines = serviceLines;
        this.clientInfos = clientInfos;
        this.creationDate = creationDate;
        this.countryIsoCode = countryIsoCode;
        this.employeeRole = employeeRole;
        this.securityDeposit = securityDeposit;
        this.paymentMethod = paymentMethod;
        this.paymentCondition = paymentCondition;
        this.withPresentationPages = withPresentationPages;
        this.bevMonthlyAmount = bevMonthlyAmount;
        this.showRenewalContent = showRenewalContent;
        this.bevNewQuoteServiceMonthlyAmount = bevNewQuoteServiceMonthlyAmount;
    }
}
